import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import OptionContent from 'ui-library/menus/OptionContent';

export const SHOW_MORE_BUTTON_VALUE = '__SHOW_MORE_BUTTON_VALUE';

export const ShowMoreOption: React.SFC<{
  name: string | JSX.Element;
  onClick: () => void;
}> = (props) => (
  <div
    onClick={(e) => {
      // We need to stopPropagation here to prevent the dropdown from closing.
      // We cannot use PreventParentClickWrapper since we need to style this
      // div with flexbox to keep it consistent with other options.
      e.stopPropagation();
      props.onClick();
    }}
    className={css(styles.showMoreOption)}
  >
    <OptionContent>
      <div className="u-faded">{props.name}</div>
    </OptionContent>
  </div>
);

const styles = StyleSheet.create({
  showMoreOption: {
    display: 'flex',
    flex: 1,
  },
});
